import Content from '@/features/pos/components/ProductConfigurationModal/Content'
import { Actions, ProductVariant } from '@/features/pos/components/ProductConfigurationModal/types'
import Modal from '@/features/ui/components/Modal'
import { FC } from 'react'

type ProductConfigurationModalProps = {
    productName?: string
    productVariants?: ProductVariant[]
    defaultProductVariantId?: string
    defaultQuantity?: number
    allowQuantityChange?: boolean
} & Actions

const ProductConfigurationModal: FC<ProductConfigurationModalProps> = ({
    productName,
    productVariants,
    defaultProductVariantId,
    defaultQuantity,
    allowQuantityChange = false,
    onConfirm,
    onCancel,
    cancelLabel,
}) => {
    return (
        <Modal contentVariant="wide">
            <Content
                productName={productName}
                productVariants={productVariants}
                defaultProductVariantId={defaultProductVariantId}
                defaultQuantity={defaultQuantity}
                allowQuantityChange={allowQuantityChange}
                onConfirm={onConfirm}
                onCancel={onCancel}
                cancelLabel={cancelLabel}
            />
        </Modal>
    )
}

export default ProductConfigurationModal
